/**
    * Transaction Report
    * Transaction Report panel will have the detail of transaction of the warehouse item in the store room
    * Author: Aparna
    * 
    * */
/**
 * TR_PC_01
 * importing action,store and SDIconstants,translation, jquery,component router
 * */
import React, { Component } from 'react';
import * as $ from 'jquery';
import * as MenuAction from '../actions/MenuAction';
import * as TransSelectAction from '../actions/TransSelectAction';
import TransSelectStore from '../stores/TransSelectStore';
import SDIConstants from '../SDIConstants';
import * as CookieService from '../CookieService';
import { withTranslation, Trans } from 'react-i18next'
import ReactPaginate from 'react-paginate';
import swal from 'sweetalert';
import Select from 'react-select';
import DatePicker from "react-datepicker";
let currentPagePath;


class TransSelectComponent extends Component {
    /**
 * TR_PC_02
 * */
    constructor(props) {
        super(props);
        //this.GoButtonClick = this.GoButtonClick.bind(this);
        /**
    * TR_PC_03
    * intilize the variable used in this component
    * */

        this.state = {
            GridData: [],
            PageNo: "1",
            SelectedReport: "X",
            Radio6: true,
            Radio12: false,
            RadioAll: false,
            ItemID: "",
            ExportToExcel: [],
            TotalCount: 0,
            isFavorited: false,
            PageCount: 0,
            ShowExportToExcel: false,
            IspageLoad: true,
            CribOptions: [],
            SelectedCrib: ""
        }
    }

    /**
    *TR_PC_04
    */
    componentDidMount() {

        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        TransSelectAction.Page_Load();
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        TransSelectAction.getCurrentFavPage(getFavPageBO);
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        // RcvRptAction.RRPageLoadAction(BO);
        TransSelectStore.on('pageloadres', this.Page_LoadResponse);
        TransSelectStore.on('TRGo', this.GoButtonClickResposne);
        TransSelectStore.on('favpage', this.loadFavPageResponse.bind(this));
        TransSelectStore.on('updateFavPage', this.updateFavPageResponse.bind(this));

    }
    /***
     * TR_PC_03
     * */
    componentWillUnmount() {
        TransSelectStore.removeListener('pageloadres', this.Page_LoadResponse);
        TransSelectStore.removeListener('TRGo', this.GoButtonClickResposne.bind(this));
        TransSelectStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        TransSelectStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
    }

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(TransSelectStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (TransSelectStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(TransSelectStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(TransSelectStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        //this.refreshMenu();
    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Transaction Report",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            TransSelectAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            TransSelectAction.deleteFavPage(deleteFavPageBO)
        }
    };

    // Regression Bug - 5138 Should restrict entering any special characters in input field - Surya K -1/27/2025

    keyPressQTY(e) {
        const invalidChars = [".", "-", "+", "e", "/", "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "="];
        if (invalidChars.includes(e.key)) e.preventDefault();
    };

    /***
     * TR_PC_06
     * */
    OnHandleChange = (e, name) => {
        switch (name) {
            case "ItemID": {
                const isValid = SDIConstants.alphanumericRegex.test(e.target.value.trim());
                if (isValid || e.target.value === "") {

                    this.setState({ ItemID: e.target.value, ShowExportToExcel: false, GridData: [], totalCount: 0, IspageLoad: true });
                }
                break;
            }
            case "Radio6": {
                this.setState({ Radio6: true, Radio12: false, RadioAll: false, ShowExportToExcel: false, GridData: [], totalCount: 0, IspageLoad: true });
                break;
            }
            case "Radio12": {
                // let dateOL = this.handledate(date);
                this.setState({ Radio6: false, Radio12: true, RadioAll: false, ShowExportToExcel: false, GridData: [], totalCount: 0, IspageLoad: true });
                break;
            }
            case "RadioAll": {
                this.setState({ Radio6: false, Radio12: false, RadioAll: true, ShowExportToExcel: false, GridData: [], totalCount: 0, IspageLoad: true });
                break;
            }
        }
    };

    ClearSearch = () => {
        this.setState({ ItemID: "" })
    }

    GoButtonClick = () => {
        if (this.state.ItemID == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter Item Id"
            });
            //alert(" enter item id")
            return
        }
        let radio = ""
        if (this.state.Radio6 == true) {
            radio = "6"
        }
        else if (this.state.Radio12 == true) {
            radio = "12"
        }
        else {
            radio = "All"
        }
        let BO = {
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            strItemid: this.state.ItemID.trim(),
            rbtSelection: radio,
            IsExportToExcel: false,
            Crib_ID: this.state.SelectedCrib.value
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        TransSelectAction.GoButtonClickAction(BO);
    }
    exportGridData = () => {
        if (this.state.ItemID == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter item id"
            });
            //  alert("Please enter item id")
            return
        }
        let radio = ""
        if (this.state.Radio6 == true) {
            radio = "6"
        }
        else if (this.state.Radio12 == true) {
            radio = "12"
        }
        else {
            radio = "All"
        }
        let BO = {
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            strItemid: this.state.ItemID,
            rbtSelection: radio,
            IsExportToExcel: true,
            Crib_ID: this.state.SelectedCrib.value
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        TransSelectAction.ExportData(BO);
    }
    Page_LoadResponse = () => {
        let Response = JSON.parse(TransSelectStore.pageloadres);
        if (Response != undefined && Response != null && Response != "") {
            if (Response.length > 0) {
                let CribArray = [];
                Response.forEach((val, index) => {
                    let locCrib = {
                        value: val.BUSINESS_UNIT,
                        label: val.DESCR,
                    }
                    CribArray.push(locCrib);
                });
                this.setState({ CribOptions: CribArray, SelectedCrib: CribArray[0] });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Oops! Something went wrong"
                });
            }
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    handleCribChange = (e) => {
        this.setState({ SelectedCrib: e, GridData: [], totalCount: 0, IspageLoad: true })
    }
    /**
     * TR_PC_08
     * */
    GoButtonClickResposne = () => {
        let Response = JSON.parse(TransSelectStore.PageLoadData);
        if (Response.GridData != "") {
            let tot = Response.GridData.length
            let count = parseFloat(Response.GridData.length) / 10
            //A1QA - 154 Transaction Report sorting is not working-Deepthi
            let locGrid = Response.GridData;
            locGrid.forEach((value, index) => {
                value.QTY = parseInt(value.QTY, 10);
                if (value.ORDER_NO == "" || value.ORDER_NO == " ") {
                    value.ORDER_NO = "0";
                }
                /*Removed Changes made for showing negative field value as qty-INC0010955 */
            });
            this.setState({ GridData: locGrid, totalCount: tot, PageCount: count, PageNo: "1", ShowExportToExcel: true, IspageLoad: false });
        }
        else {
            this.setState({ GridData: [], totalCount: 0, PageCount: 0, IspageLoad: false });
        }
    }
    /**
     * TR_PC_10
     * */
    export = () => {
        /*[02/18/22, PC_01 WW-327], Priyanka D,Transaction Report */
        //dt = this.state.GridData
        const EX = ['Transaction Date', 'UOM', 'QTY', 'Group', 'Order No.', 'Line No.', 'PO No.', 'Work Order', 'Operator Entered By',
            'Trans. Operid', 'Storeroom', 'St. room Descr.', 'Crib id']
        let locArr = [];
        this.state.GridData.map((X) => {
            let loc = {
                TRANSACTION_DATE: X.DT_TIMESTAMP,
                UNIT_MEASURE_STD: X.UNIT_MEASURE_STD,
                QTY: X.QTY,
                TRANSACTION_GROUP: X.TRANSACTION_GROUP,
                ORDER_NO: X.ORDER_NO,
                ORDER_INT_LINE_NO: X.ORDER_INT_LINE_NO,
                PO_ID: X.PO_ID,
                ISA_WORK_ORDER_NO: X.ISA_WORK_ORDER_NO,
                OPRID1: X.OPRID1,
                OPRID: X.OPRID,
                Storeroom: "Storeroom",
                STRM: "STRM",
                Crib_id: X.BUSINESS_UNIT /*[02/18/22, PC_01 WW-327], Priyanka D,Transaction Report */
            }
            locArr.push(loc)
        })
        // let myArr = [...this.state.GridData]
        //this.setState({ isexport: true, Arr: locArr });
        //[12/30/21, PC_SC_04], Priyanka D//Invoke "convertArrayToTable" for exporting Excel in .xls form*/
        /*[02/18/22, PC_01 WW-327], Priyanka D,Transaction Report */
        this.convertArrayToTable(locArr, "Transaction Report");
        //this.exporttoexcel(locArr);
    }
    /**
     * TR_PC_11
     * */

    convertArrayToTable = (locArr, Exporttoexcel) => {
        //use keys from the first array object to form table column headers
        const tableHeaders = `<tr>${Object.keys(locArr[0]).map(key => `<td>${key}</td>`).join('')}</tr>`;
        //now loop through all array objects to form table rows
        const tableRows = locArr.map(obj =>
            [`<tr>
         ${Object.keys(obj).map(key => `<td>${obj[key] === null || obj[key] === '' ? '' : obj[key]}</td>`).join('')}
      <tr/>`]).join('');
        const table = `<table>${tableHeaders}${tableRows}</table>`.trim();


        const xmlTable = this.createXMLTable(table, "Build Excel");
        const downloadURL = this.createFileUrl(xmlTable);
        this.downloadFile(downloadURL, Exporttoexcel);
    }
    /**
     * TR_PC_14
     * */

    createXMLTable = (table, fileName) => {
        const xmlTable = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office xmlns:x="urn:schemas-microsoft-com:office:excel"
       xmlns="http://www.w3.org/TR/REC-html40"
        >
           <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"/>
           <head>
              <xml>
                <x:ExcelWorkbook>
                    <x:ExcelWorksheets>
                        <x:ExcelWorksheet>
                            <x:Name>${fileName}</x:Name>
                            <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                        </x:ExcelWorksheet>
                    </x:ExcelWorksheets>
                </x:ExcelWorkbook>
              </xml>
           </head>
           <body>
             ${table}
           </body>
        </html> `
        return xmlTable;
    }
    /**
     *TR_PC_12
     **/
    createFileUrl = (xmlTable) => {
        const tableBlob = new Blob([xmlTable], { type: 'application/vnd.ms-excel;base64,' });
        const downloadURL = URL.createObjectURL(tableBlob);
        return downloadURL;
    }
    /**
     * TR_PC_13
     * */
    downloadFile = (downloadURL, fileName) => {
        const downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
        downloadLink.download = fileName;
        downloadLink.href = downloadURL;
        downloadLink.click();
    }

    /**
     * TR_PC_15
     * */
    /*[10/19/22,A1QA-154-User defined sorting], Priyanka D */
    sort = (Arr, indexval, nextindexval, Type) => {
        let temp = []
        let size = Arr.length
        let i, j = 0;

        if (Type == "ASC") {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    if (eval(indexval) > eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        } else {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    if (eval(indexval) < eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        }
    }

    Sorting = (sort, name) => {

        let a = this.state.GridData;
        let data = [];
        if (sort == "ASC") {
            switch (name) {
                case "TRANSACTION_DATE": {
                    //A1QA - 154 Transaction Report sorting is not working-Deepthi
                    data = this.state.GridData.sort((a, b) => (new Date(a.DT_TIMESTAMP).getTime() > new Date(b.DT_TIMESTAMP).getTime()) ? 1 : -1);
                    //data = this.ManualSort(this.state.GridData,"DESC");
                    break;
                }
                case "UNIT_MEASURE_STD": {
                    data = this.sort(this.state.GridData, "Arr[i].UNIT_MEASURE_STD", "Arr[j].UNIT_MEASURE_STD", "ASC")
                    //data = this.state.GridData.sort((a, b) => (a.UNIT_MEASURE_STD > b.UNIT_MEASURE_STD) ? 1 : -1)
                    break;
                }
                case "QTY": {
                    ////A1QA - 154 Transaction Report sorting is not working-Deepthi
                    data = this.sort(this.state.GridData, "Arr[i].QTY", "Arr[j].QTY", "ASC")
                    //data = this.state.GridData.sort((a, b) => (Number(a.QTY) > Number(b.QTY)) ? -1 : 1);
                    break;
                }
                case "TRANSACTION_GROUP": {
                    data = this.sort(this.state.GridData, "Arr[i].TRANSACTION_GROUP", "Arr[j].TRANSACTION_GROUP", "ASC")
                    break;
                }
                case "ORDER_NO": {
                    data = this.sort(this.state.GridData, "Arr[i].ORDER_NO", "Arr[j].ORDER_NO", "ASC")
                    //data = this.state.GridData.sort((a, b) => (String(a.ORDER_NO) > String(b.ORDER_NO)) ? 1 : -1)
                    break;
                } case "ORDER_INT_LINE_NO": {
                    data = this.sort(this.state.GridData, "Arr[i].ORDER_INT_LINE_NO", "Arr[j].ORDER_INT_LINE_NO", "ASC")
                    // data = this.state.GridData.sort((a, b) => (a.ORDER_INT_LINE_NO > b.ORDER_INT_LINE_NO) ? 1 : -1)
                    break;
                }
                case "PO_ID": {
                    //A1QA - 154 Transaction Report sorting is not working-Deepthi
                    data = this.sort(this.state.GridData, "Arr[i].PO_ID", "Arr[j].PO_ID", "ASC")
                    //data = this.state.GridData.sort((a, b) => (a.PO_ID > b.PO_ID) ? 1 : -1)
                    break;
                }
                case "ISA_WORK_ORDER_NO": {
                    data = this.sort(this.state.GridData, "Arr[i].ISA_WORK_ORDER_NO", "Arr[j].ISA_WORK_ORDER_NO", "ASC")
                    //data = this.state.GridData.sort((a, b) => (a.ISA_WORK_ORDER_NO > b.ISA_WORK_ORDER_NO) ? 1 : -1)
                    break;
                } case "OPRID1": {
                    data = this.sort(this.state.GridData, "Arr[i].OPRID1", "Arr[j].OPRID1", "ASC")
                    //data = this.state.GridData.sort((a, b) => (a.OPRID1 > b.OPRID1) ? 1 : -1)
                    break;
                } case "OPRID": {
                    data = this.sort(this.state.GridData, "Arr[i].OPRID", "Arr[j].OPRID", "ASC")
                    data = this.state.GridData.sort((a, b) => (a.OPRID > b.OPRID) ? 1 : -1)
                    break;
                }

            }
        }
        else {
            switch (name) {
                /*[02/17/22, PC_01 WBW-31], Priyanka D,Transaction Report */
                case "TRANSACTION_DATE": {
                    //A1QA - 154 Transaction Report sorting is not working-Deepthi
                    data = this.state.GridData.sort((a, b) => (new Date(b.DT_TIMESTAMP).getTime() > new Date(a.DT_TIMESTAMP).getTime()) ? 1 : -1);
                    //data = this.ManualSort(this.state.GridData, "ASC");
                    break;
                }
                case "UNIT_MEASURE_STD": {
                    data = this.sort(this.state.GridData, "Arr[i].UNIT_MEASURE_STD", "Arr[j].UNIT_MEASURE_STD", "DESC")
                    //data = this.state.GridData.sort((a, b) => (b.UNIT_MEASURE_STD > a.UNIT_MEASURE_STD) ? 1 : -1)
                    break;
                }
                case "QTY": {
                    //A1QA - 154 Transaction Report sorting is not working-Deepthi
                    data = this.sort(this.state.GridData, "Arr[i].QTY", "Arr[j].QTY", "DESC")
                    // data = this.state.GridData.sort((a, b) => (b.QTY > a.QTY) ? 1 : -1);
                    //data = this.state.GridData.sort((a, b) => (Number(b.QTY) > Number(a.QTY)) ? -1 : 1)
                    break;
                }
                case "TRANSACTION_GROUP": {
                    data = this.sort(this.state.GridData, "Arr[i].TRANSACTION_GROUP", "Arr[j].TRANSACTION_GROUP", "DESC")
                    //data = this.state.GridData.sort((a, b) => (b.TRANSACTION_GROUP > a.TRANSACTION_GROUP) ? 1 : -1)
                    break;
                }
                case "ORDER_NO": {
                    data = this.sort(this.state.GridData, "Arr[i].ORDER_NO", "Arr[j].ORDER_NO", "DESC")
                    //data = this.sort(this.state.GridData, "ORDER_NO", "DESC")
                    //data = this.state.GridData.sort((a, b) => (b.ORDER_NO > a.ORDER_NO) ? 1 : -1)
                    break;
                } case "ORDER_INT_LINE_NO": {
                    data = this.sort(this.state.GridData, "Arr[i].ORDER_INT_LINE_NO", "Arr[j].ORDER_INT_LINE_NO", "DESC")
                    //data = this.state.GridData.sort((a, b) => (b.ORDER_INT_LINE_NO > a.ORDER_INT_LINE_NO) ? 1 : -1)
                    break;
                }
                case "PO_ID": {
                    data = this.sort(this.state.GridData, "Arr[i].PO_ID", "Arr[j].PO_ID", "DESC")
                    // data = this.state.GridData.sort((a, b) => (b.PO_ID > a.PO_ID) ? 1 : -1)
                    break;
                }
                case "ISA_WORK_ORDER_NO": {
                    data = this.sort(this.state.GridData, "Arr[i].ISA_WORK_ORDER_NO", "Arr[j].ISA_WORK_ORDER_NO", "DESC")
                    //data = this.state.GridData.sort((a, b) => (b.ISA_WORK_ORDER_NO > a.ISA_WORK_ORDER_NO) ? 1 : -1)
                    break;
                } case "OPRID1": {
                    data = this.sort(this.state.GridData, "Arr[i].OPRID1", "Arr[j].OPRID1", "DESC")
                    //data = this.state.GridData.sort((a, b) => (b.OPRID1 > a.OPRID1) ? 1 : -1)
                    break;
                    /*[02/18/22, PC_01 WW-327], Priyanka D,Transaction Report */
                } case "OPRID": {
                    data = this.sort(this.state.GridData, "Arr[i].OPRID", "Arr[j].OPRID", "DESC")
                    //data = this.state.GridData.sort((a, b) => (b.OPRID > a.OPRID) ? 1 : -1)
                    break;
                }

            }

        }
        this.setState({ GridData: data })
    }
    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ PageNo: pageNo });
    }
    //CPW-88/WW-769 Transaction History does not show Zeus User ID that performed transaction - Deepthi N H
    formatDate = (dateString) => {

        let parts = dateString.split('-');
        if (parts.length >= 4) {
            let year = parseInt(parts[0]);
            let month = parts[1];
            let day = parts[2];
            let time = parts[3];
            let timeSplit = time.split('.');
            let hours;
            let minutes;
            let seconds;
            if (timeSplit.length >= 3) {
                hours = timeSplit[0];
                minutes = timeSplit[1];
                seconds = timeSplit[2];
            }
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
    }
    /**
     * TR_PC_07
     * */
    BindDataGrid = () => {
        return this.state.GridData.map((value, index) => {
            //CPW-88/WW-769 Transaction History does not show Zeus User ID that performed transaction - Deepthi N H
            let date = value.DT_TIMESTAMP;
            if (index < parseInt(this.state.PageNo) * 10 && index >= parseInt(this.state.PageNo - 1) * 10) {
                //WBW-31_PC_02 to show the negative qty value when FIELDVALUE is "034"
                //A1QA - 154 Transaction Report sorting is not working-Deepthi
                return (
                    <React.Fragment key={index}>
                        <tr>


                            {/* <td className="d-sm-none d-md-table-cell"><div style={{ width: '100px' }}><a href="#" className="order-id" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target=".orderstatus-popup" onClick={e => this.PopupForLineLevelDetails(index, value, "V")} >{value.NAME1}</a></div></td>*/}

                            <td className="d-md-table-cell  text-nowrap" >{date}</td>
                            <td className="d-md-table-cell" >{value.UNIT_MEASURE_STD}</td>
                            <td className="d-md-table-cell" ><div >{value.QTY}</div></td>
                            <td className="d-md-table-cell" ><div >{value.ON_HAND_QTY}</div></td>
                            <td className="d-md-table-cell  text-nowrap">{value.TRANSACTION_GROUP}</td>
                            <td className="d-md-table-cell  text-nowrap"><div >{value.ORDER_NO == "0" ? "" : value.ORDER_NO}</div></td>
                            <td className="d-md-table-cell"><div >{value.ORDER_INT_LINE_NO}</div></td>
                            {/*<td className="d-none d-sm-none d-md-table-cell priority-alert">{value.LINE_PRIOR}</td>*/}
                            {/* <td className="d-none d-sm-none d-md-table-cell">{value.ENTEREDEMPNAME}</td>*/}
                            <td className="d-md-table-cell  text-nowrap"><div >{value.PO_ID}</div></td>
                            <td className="d-md-table-cell  text-nowrap"><div >{value.ISA_WORK_ORDER_NO}</div></td>
                            <td className="d-md-table-cell"><div >{value.OPRID1}</div></td>
                            <td className="d-md-table-cell  text-nowrap"><div >{value.OPRID}</div></td>
                            <td className="d-md-table-cell"><div >Storeroom</div></td>
                            <td className="d-md-table-cell"><div >STRM</div></td>
                            <td className="d-md-table-cell"><div >{value.BUSINESS_UNIT}</div></td>
                            {/* <td className="d-none d-sm-none d-md-table-cell"><div >{value.BUSINESS_UNIT}</div></td>
                            <td className="d-none d-sm-none d-md-table-cell"><div >{value.STORAGE_AREA}</div></td>*/}
                        </tr>

                    </React.Fragment>

                )

            }

        });
    }
    render() {
        return (
            <div>
                <div className="container-fluid content-section content-margin custom-mb">
                    <div className="row">
                        <div className="col-md-12 page-heading mb-3 ">
                            <h5 className="page-title"><Trans>Transaction Report</Trans></h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-OrdStatus">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>


                        <div className="col-md-3 mb-3">
                            <label className="catalog-label w-100"><Trans>Crib ID</Trans></label>
                            <Select
                                id="buddid"
                                name="BuDD"
                                onChange={(e) => this.handleCribChange(e)}
                                value={this.state.SelectedCrib}
                                defaultValue="Select"
                                options={this.state.CribOptions}
                            />
                        </div>
                        <div className="col-md-3  mb-3">
                            <label className="catalog-label w-100"><Trans>Item ID</Trans></label>
                            <input type="text" className="form-control pr-4" placeholder="Search" maxLength="9" value={this.state.ItemID} onChange={e => this.OnHandleChange(e, "ItemID")} id="SearchCriteria" onKeyDown={(e) => this.keyPressQTY(e)} />
                            {this.state.ItemID ? <span className="search-cancel-header cursor-pointer" style={{ "right": "20px","top":"42px" }} onClick={() => this.ClearSearch()}></span> : null}
                        </div>
                        <div className="col-md-3  mb-3">
                            <label className="catalog-label w-100"><Trans>Choose Report</Trans></label>
                            <label className="custom-radiobtn cust-resp-width" id="ex"><Trans>6 Months</Trans>
                                <input type="radio" name="TRradio" id="6month" checked={this.state.Radio6} onChange={(e) => this.OnHandleChange(e, "Radio6")} />
                                <span className="checkmark checkmark-org" />
                            </label>
                            <label className="custom-radiobtn cust-resp-width" id="6m"><Trans>12 Months</Trans>
                                <input type="radio" name="TRradio" id="12month" className="6month" checked={this.state.Radio12} onChange={(e) => this.OnHandleChange(e, "Radio12")} />
                                <span className="checkmark checkmark-org " />
                            </label>
                            <label className="custom-radiobtn cust-resp-width" id="dr"><Trans>All</Trans>
                                <input type="radio" name="TRradio" id="allmonth" checked={this.state.RadioAll} onChange={(e) => this.OnHandleChange(e, "RadioAll")} />
                                <span className="checkmark checkmark-org" />
                            </label>
                        </div>
                        <div className="col-md-3  mb-3">
                            <button className="btn btn-primary custom-btn-primary primary-btn px-4 mt-4" onClick={this.GoButtonClick} ><Trans>Apply</Trans><span> </span> <Trans>Filter</Trans></button>
                        </div>



                        {!this.state.IspageLoad ? <div className="col-lg-12 my-3">
                            {!this.state.IspageLoad ? <div className="d-flex justify-content-end mb-3">
                                {this.state.totalCount > 0 && this.state.ShowExportToExcel == true ? <>
                                    {/*<button className="btn btn-primary custom-btn-primary primary-btn float-left mr-3" onClick={this.addFavItemsToCart}><Trans>Buy Checked Items</Trans></button>*/}
                                    {/*<button className="btn btn-primary custom-btn-primary primary-btn float-left mr-3" onClick={this.expandAll}><Trans>{!this.state.isExpand ? `Expand All` : `Collapse All`}</Trans></button>*/}
                                    <button className="btn btn-primary custom-btn-primary primary-btn" onClick={this.exportGridData}><Trans>Export to Excel</Trans></button></> : null}
                            </div> : null}
                            <div className="table-responsive">
                                <table className="table ZEUS_Grid FOM-grid">
                                    <thead>
                                        <tr>
                                            <th className="d-md-table-cell position-sort-icon pr-3"><Trans>Transaction Date</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "TRANSACTION_DATE")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "TRANSACTION_DATE")}><img src="Images/sort1.svg" /></span></th>
                                            <th className="d-md-table-cell position-sort-icon pr-3"><Trans>UOM</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "UNIT_MEASURE_STD")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "UNIT_MEASURE_STD")}><img src="Images/sort1.svg" /></span></th>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>QTY</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>On Hand Qty</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon pr-3"><Trans>Group</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "TRANSACTION_GROUP")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "TRANSACTION_GROUP")}><img src="Images/sort1.svg" /></span></th>
                                            <th className="d-md-table-cell position-sort-icon pr-3"><Trans>Order No</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "ORDER_NO")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "ORDER_NO")}><img src="Images/sort1.svg" /></span></th>
                                            <th className="d-md-table-cell position-sort-icon pr-3"><Trans>Line No</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "ORDER_INT_LINE_NO")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "ORDER_INT_LINE_NO")}><img src="Images/sort1.svg" /></span></th>
                                            <th className="d-md-table-cell position-sort-icon pr-3"><Trans>PO No</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "PO_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "PO_ID")}><img src="Images/sort1.svg" /></span></th>
                                            <th className="d-md-table-cell position-sort-icon pr-3"><Trans>Work Order</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "ISA_WORK_ORDER_NO")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "ISA_WORK_ORDER_NO")}><img src="Images/sort1.svg" /></span></th>
                                            <th className="d-md-table-cell position-sort-icon pr-3"><Trans>Operator Entered By</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "OPRID1")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "OPRID1")}><img src="Images/sort1.svg" /></span></th>
                                            <th className="d-md-table-cell position-sort-icon pr-3"><Trans>Trans. Operid</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "OPRID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "OPRID")}><img src="Images/sort1.svg" /></span></th>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>Storeroom</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>St. room Descr.</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>Crib id</Trans></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.totalCount > 0 ? this.BindDataGrid() :
                                            (

                                                <tr>
                                                    <td></td>
                                                    <td></td>

                                                    <td colSpan={11}>
                                                        <section className="site-undercontruction container text-center center-panel pt-4">
                                                            <div className="img-section">
                                                                <img src="images/nosearch.jpg" alt="imagefile" />
                                                            </div>
                                                            <p className="search-result-content pt-4"><Trans>Sorry, we couldn’t find any search result</Trans>
                                                            </p>
                                                        </section>
                                                    </td>
                                                </tr>)}

                                    </tbody>
                                </table>
                            </div>
                        </div> : null}

                        {this.state.GridData.length > 0 ?
                            <div className="col-md-12 ">
                                <span className="total-records mt-2 d-inline-block">
                                    <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.GridData.length}</span>
                                </span>
                                {this.state.GridData.length > 10 ? <ReactPaginate
                                    previousLabel={<span className="right-pagination-arrow" />}
                                    nextLabel={<span className="left-pagination-arrow" />}
                                    previousClassName={'page-item'}
                                    nextClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextLinkClassName={'page-link'}
                                    disabledClassName={'disabled'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={this.state.PageCount}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={2}
                                    onPageChange={e => this.handlePageClick(e)}
                                    containerClassName={'custom-pagination pagination float-right'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                    hrefBuilder={() => '#'}
                                    forcePage={this.state.PageNo - 1}
                                /> : null}

                            </div> : null}




                    </div>
                </div>
            </div>
        )

    }
}
export default withTranslation()(TransSelectComponent);
